export const uppercaseFirstLetterOnly = (string) =>
  string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()

export const extractErrorMessage = (error) =>
  error.response && error.response.data.message
    ? error.response.data.message
    : error.message
